import React from 'react';
import { Navigate } from 'react-router-dom';
import Loader from '../shared/Loader';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
    children: React.ReactNode;
}

/**
 * Компонент защищенного маршрута
 * 
 * Отвечает за:
 * - Проверку авторизации через контекст AuthContext
 * - Перенаправление неавторизованных пользователей на страницу входа
 * - Отображение защищенного контента только для авторизованных пользователей
 * 
 * @param {React.ReactNode} children - компоненты, которые должны быть защищены
 */
export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const { authenticated, loading } = useAuth();

    // Показываем индикатор загрузки, если проверка еще идет
    if (loading) {
        return <Loader />;
    }

    // Если пользователь не авторизован, перенаправляем на страницу входа
    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    // Если пользователь авторизован, отображаем защищенный контент
    return <>{children}</>;
};